"use client"
import { Suspense } from "react"
import { endOfWeek, format } from "date-fns"
import { Workout } from "@/models/workout"
import { Text } from "../Text"
import FixedAddButton from "../FixedAddButton"
import { groupWorkoutsByDate } from "@/app/utils/workouts"
import { LoadingRing } from "../LoadingRing"
import WorkoutCard from "./WorkoutCard"

type WorkoutsListProps = {
  workouts: Workout[]
  isPublic: boolean
}

const WorkoutsList = ({ workouts, isPublic }: WorkoutsListProps) => {
  if (workouts.length === 0 && isPublic) {
    return (
      <div className="w-full max-w-xl flex flex-col items-center gap-3">
        <Text className="text-center py-2 mx-auto">
          No workouts logged yet!
        </Text>
      </div>
    )
  }

  const { groupedWorkouts, sortedWeeks } = groupWorkoutsByDate(workouts)
  return (
    <>
      {sortedWeeks.map((weekStart) => {
        const workouts = groupedWorkouts[weekStart]
        const startDate = new Date(weekStart)
        let endDate: Date | string = endOfWeek(startDate, { weekStartsOn: 1 })

        if (endDate > new Date()) {
          endDate = "Today"
        } else {
          endDate = format(endDate, "MMM d, yyyy")
        }

        return (
          <div key={weekStart} className="w-full max-w-xl mb-2">
            <Text className="text-center font-bold py-2 mx-auto">
              {format(startDate, "MMM d, yyyy")} - {endDate}
            </Text>
            <ul className="w-full flex flex-col items-center gap-3">
              {workouts.map((workout) => {
                return (
                  <Suspense key={workout.id} fallback={<LoadingRing />}>
                    <WorkoutCard
                      key={workout.id}
                      workout={workout}
                      isPublic={isPublic}
                    />
                  </Suspense>
                )
              })}
              {!isPublic && <FixedAddButton type="workout" />}
            </ul>
          </div>
        )
      })}
    </>
  )
}

export default WorkoutsList
